import React from "react";
import { createImageFromInitials } from "../../AgentLogo";
import Avatar from "../../static/images/Chat_icon.png";

export default function InvestmentChatHeader({ agentName, showModal, messageCounter, botName, miniMize }) {
  return (
    <header>
      <div class="heading-with-icon">
        <div class="chaticon" alt="">
          <div className="onlineDot"></div>
            <img src={Avatar} alt=""></img>
        </div>
        <div className="bot-name">
          <h3>{agentName ? agentName : "Ask PB" || "Policybazaar"}</h3>
          <p>Investment Assistance</p>
          <div className="carRating"></div>
        </div>
        <div className="endchat">
          <div onClick={() => miniMize()} className="minimizeIcon">&minus;</div>
        </div>

      </div>
    </header>
  );
}